import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

const httpLink = createHttpLink({


 //uri: 'https://backend.smartclinic.tk/graphql',
 //uri:'http://localhost:3003/graphql',
//uri: 'http://194.5.159.215:3003/graphql',
//uri: 'https://drnasef-clinicsystem.ahmedmattar.tech/apigraphql'
uri: 'https://myclinic.drnasef.com/apigraphql'

});

const authLink = setContext((_, { headers }) => {

  const token =  localStorage.getItem("token");
  
  
  
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const defaultOptions= {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}


const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions
});

export default client
